module.exports = __webpack_public_path__ + "img/Lynx.d88a2779.png";